import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import capitalize from 'lodash.capitalize';
import { Mail } from 'lucide-react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormMessage, } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { useHeader } from '@/newComponents/Header/useHeader';
import { chatModalState, isWidgetExpandedState } from '@/state/session';
import { emailRegExp } from '@/util/utils';
export const EmailModal = () => {
    const { t } = useTranslation();
    const { handleSendConversationViaEmail } = useHeader();
    const setChatModal = useSetRecoilState(chatModalState);
    const isExpanded = useRecoilValue(isWidgetExpandedState);
    const handleSend = useCallback(async (data) => {
        handleSendConversationViaEmail(data.email);
    }, [handleSendConversationViaEmail]);
    const handleCancel = useCallback(() => {
        setChatModal(null);
    }, [setChatModal]);
    const form = useForm({
        defaultValues: {
            email: '',
        },
    });
    const field = 'email';
    return (_jsx(Form, Object.assign({}, form, { children: _jsxs("div", { className: "flex h-full flex-col items-center gap-4 p-4 text-center", children: [_jsx(Mail, { size: 24 }), _jsx("div", { className: "text-lg leading-none font-semibold", children: "Send Conversation via Email" }), _jsx("div", { className: "flex w-full flex-col items-center justify-center", children: _jsx(FormField, { control: form.control, name: field, rules: {
                            required: t('fields.required', { field: capitalize(field) }),
                            pattern: {
                                value: emailRegExp,
                                message: t('fields.invalid', { field: capitalize(field) }),
                            },
                        }, render: ({ field: controllerField }) => {
                            return (_jsxs(FormItem, { className: "w-full", children: [_jsx(FormControl, { children: _jsx(Input, Object.assign({}, controllerField, { className: "mt-4 w-full", placeholder: t(`fields.${field}`), id: field })) }), _jsx(FormMessage, {})] }));
                        } }) }), _jsxs("div", { className: "flex w-full flex-col items-center justify-center gap-2", children: [_jsx(Button, { onClick: form.handleSubmit(handleSend), className: cn('w-full', {
                                'w-sm': isExpanded,
                            }), children: t('buttons.send') }), _jsx(Button, { onClick: handleCancel, variant: "secondary", className: cn('w-full', {
                                'w-sm': isExpanded,
                            }), children: t('buttons.cancel') })] })] }) })));
};
